import * as types from '../mutation-types'

export default {
	namespaced: true,
	state: {
		transactions: [],
		transactionsJournal: []
	},

	actions: {
		fetchAll({ commit }) {
			return window.axios.get('/materialTransactions/selfTransactionsSummary')
				.then((response) => {
					commit(types.STORE_TRANSACTIONS_SUMMARY, response.data);
					return response.data;
				});
		},

		fetchJournal({ commit }) {
			return window.axios.get('/MaterialTransactions/TransactionsJournal')
				.then((response) => {
					commit(types.STORE_TRANSACTIONS_JOURNAL, response.data);
					return response.data;
				});
		},
        
		reset({ commit }) {
			commit(types.RESET_TRANSACTIONS_SUMMARY);
		},

		resetJournal({ commit }) {
			commit(types.RESET_TRANSACTIONS_JOURNAL);
		}
	},

	mutations: {
		[types.STORE_TRANSACTIONS_SUMMARY](state, transactions) {
			state.transactions = transactions;
		},

		[types.STORE_TRANSACTIONS_JOURNAL](state, transactionsJournal) {
			state.transactionsJournal = Array.isArray(transactionsJournal) ? transactionsJournal : [];
		},

		[types.RESET_TRANSACTIONS_SUMMARY](state) {
			state.transactions = [];
		},

		[types.RESET_TRANSACTIONS_JOURNAL](state) {
			state.transactionsJournal = [];
		},
	},

	getters: {
		getTransactionById: state => id => state.transactions.find(c => c.id === id),
		getJournalTransactionById: state => id => state.transactionsJournal.find(c => c.id === id),
	}
}